export const SUPPORTED_LANGUAGES = [
  { label: 'English', value: 'en-GB', flag: '🇬🇧' },
  { label: 'Deutsch', value: 'de-DE', flag: '🇩🇪' },
  { label: '中文', value: 'zh-CN', flag: '🇨🇳' },
] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['value']

export function isSupportedLanguage(
  language: string
): language is SupportedLanguage {
  return SUPPORTED_LANGUAGES.some((entry) => entry.value === language)
}

/** Default content language for compliance-studio generation flows. */
export const STANDARD_SOURCE_LANGUAGE: SupportedLanguage = 'en-GB'

/** All locales users may select as translation targets in standards extraction. */
export const TRANSLATION_TARGET_LANGUAGES = SUPPORTED_LANGUAGES
